
/* ==========================================
   NUTRIBOO — PRODUCT HERO
   Galerie, saveurs, formules et panier
   ========================================== */

(function () {
  "use strict";

  function initNutribooHero(section) {
    if (!section || section.dataset.nbInitialized === "true") {
      return;
    }

    section.dataset.nbInitialized = "true";

    const mainMedia = section.querySelector(
      "[data-nb-main-media]"
    );

    const thumbs = Array.from(
      section.querySelectorAll("[data-nb-thumb]")
    );

    const flavorButtons = Array.from(
      section.querySelectorAll("[data-nb-flavor]")
    );

    const planButtons = Array.from(
      section.querySelectorAll("[data-nb-plan]")
    );

    const priceElement = section.querySelector(
      "[data-nb-price]"
    );

    const quantityBox = section.querySelector(
      "[data-nb-quantity-box]"
    );

    const quantityInput = section.querySelector(
      "[data-nb-qty-input]"
    );

    const minusButton = section.querySelector(
      "[data-nb-qty-minus]"
    );

    const plusButton = section.querySelector(
      "[data-nb-qty-plus]"
    );

    const addLink = section.querySelector(
      "[data-nb-add-link]"
    );

    function readVariants(selector) {
      const element = section.querySelector(selector);

      if (!element) return [];

      try {
        const data = JSON.parse(element.textContent);
        return Array.isArray(data) ? data : [];
      } catch (error) {
        console.warn(
          "Nutriboo : impossible de lire les variantes.",
          error
        );
        return [];
      }
    }

    const oneTimeVariants = readVariants(
      "[data-nb-variants-one]"
    );

    const subscriptionVariants = readVariants(
      "[data-nb-variants-sub]"
    );

    let selectedPlan = "one-time";

    let selectedFlavor =
      flavorButtons.find((button) =>
        button.classList.contains("is-selected")
      )?.dataset.nbFlavor ||
      flavorButtons[0]?.dataset.nbFlavor ||
      "";

    let quantity = 1;

    /* ======================================
       GALERIE
       ====================================== */

    function changeImage(src, activeThumb) {
      if (!mainMedia || !src) return;

      const image = mainMedia.querySelector("img");

      if (!image) return;

      image.src = src;
      image.removeAttribute("srcset");
      image.removeAttribute("sizes");

      thumbs.forEach((thumb) => {
        thumb.classList.toggle(
          "is-active",
          thumb === activeThumb
        );
      });
    }

    thumbs.forEach((thumb) => {
      thumb.addEventListener("click", function () {
        changeImage(
          thumb.dataset.src,
          thumb
        );
      });
    });

    /* ======================================
       SAVEURS
       ====================================== */

    function normalizeText(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase();
    }

    function findVariant(variants) {
      if (!variants.length) return null;

      if (!selectedFlavor) {
        return variants.find((v) => v.available) || null;
      }

      const normalizedFlavor = normalizeText(
        selectedFlavor
      );

      return variants.find((variant) => {
        return normalizeText(
          variant.option1
        ) === normalizedFlavor;
      }) || null;
    }

    function getSelectedVariant() {
      const variants =
        selectedPlan === "subscription"
          ? subscriptionVariants
          : oneTimeVariants;

      return findVariant(variants);
    }

    function selectFlavor(flavor) {
      selectedFlavor = flavor;

      flavorButtons.forEach((button) => {
        const selected =
          button.dataset.nbFlavor === flavor;

        button.classList.toggle(
          "is-selected",
          selected
        );

        button.setAttribute(
          "aria-pressed",
          String(selected)
        );
      });

      updatePurchase();
    }

    flavorButtons.forEach((button) => {
      button.addEventListener("click", function () {
        if (button.disabled) return;

        selectFlavor(button.dataset.nbFlavor);
      });
    });

    /* ======================================
       FORMULES
       ====================================== */

    function selectPlan(plan) {
      selectedPlan =
        plan === "subscription"
          ? "subscription"
          : "one-time";

      planButtons.forEach((button) => {
        const selected =
          button.dataset.nbPlan === selectedPlan;

        button.classList.toggle(
          "is-selected",
          selected
        );

        button.setAttribute(
          "aria-pressed",
          String(selected)
        );
      });

      if (priceElement) {
        priceElement.textContent =
          selectedPlan === "subscription"
            ? priceElement.dataset.subscriptionPrice
            : priceElement.dataset.oneTimePrice;
      }

      if (quantityBox) {
        quantityBox.classList.toggle(
          "is-hidden",
          selectedPlan === "subscription"
        );
      }

      if (selectedPlan === "subscription") {
        quantity = 1;

        if (quantityInput) {
          quantityInput.value = "1";
        }
      }

      updatePurchase();
    }

    planButtons.forEach((button) => {
      button.addEventListener("click", function () {
        selectPlan(button.dataset.nbPlan);
      });
    });

    /* ======================================
       QUANTITE
       ====================================== */

    function setQuantity(value) {
      const parsed = parseInt(value, 10);

      quantity = Number.isFinite(parsed)
        ? Math.max(1, Math.min(99, parsed))
        : 1;

      if (quantityInput) {
        quantityInput.value = String(quantity);
      }

      updatePurchase();
    }

    if (minusButton) {
      minusButton.addEventListener("click", () => {
        setQuantity(quantity - 1);
      });
    }

    if (plusButton) {
      plusButton.addEventListener("click", () => {
        setQuantity(quantity + 1);
      });
    }

    if (quantityInput) {
      quantityInput.addEventListener("change", () => {
        setQuantity(quantityInput.value);
      });

      quantityInput.addEventListener("input", () => {
        if (quantityInput.value !== "") {
          setQuantity(quantityInput.value);
        }
      });
    }

    /* ======================================
       AJOUT AU PANIER
       ====================================== */

    function updatePurchase() {
      if (!addLink) return;

      const variant = getSelectedVariant();

      if (!variant || !variant.available) {
        addLink.setAttribute(
          "aria-disabled",
          "true"
        );

        addLink.removeAttribute("href");
        addLink.textContent = "Indisponible";
        return;
      }

      addLink.setAttribute(
        "aria-disabled",
        "false"
      );

      const cartAddUrl =
        addLink.dataset.cartAddUrl ||
        "/cart/add";

      const finalQuantity =
        selectedPlan === "subscription"
          ? 1
          : quantity;

      const separator = cartAddUrl.includes("?")
        ? "&"
        : "?";

      const url =
        cartAddUrl +
        separator +
        "id=" +
        encodeURIComponent(variant.id) +
        "&quantity=" +
        encodeURIComponent(finalQuantity) +
        "&return_to=" +
        encodeURIComponent("/cart");

      addLink.href = url;
      addLink.textContent = "Ajouter au panier";
    }

    /* ======================================
       INITIALISATION
       ====================================== */

    selectPlan("one-time");
    updatePurchase();
  }

  function initAllNutribooHeroes(root) {
    const context = root || document;

    if (
      context.matches &&
      context.matches(".nb-product-hero")
    ) {
      initNutribooHero(context);
    }

    context
      .querySelectorAll(".nb-product-hero")
      .forEach(initNutribooHero);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      function () {
        initAllNutribooHeroes(document);
      }
    );
  } else {
    initAllNutribooHeroes(document);
  }

  /* Shopify Theme Editor */

  document.addEventListener(
    "shopify:section:load",
    function (event) {
      initAllNutribooHeroes(event.target);
    }
  );
})();
